import { render, staticRenderFns } from "./LoadingCommonTopic.vue?vue&type=template&id=1cbfb266&"
import script from "./LoadingCommonTopic.vue?vue&type=script&lang=ts&"
export * from "./LoadingCommonTopic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports